/* lp-carousel.js — the photograph carousel in each collection row (sections/lp-collection-rows.liquid).
   A scroll-snapping strip: the visitor swipes it, or steps it with the arrows, the dots or the arrow keys. No
   autoplay (Luke, 24 Sep 2026: "a carousel that the user can use to swap through images"). The arrows hide at
   either end; the dot for the photograph in view is filled. 24 Sep 2026. */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('lp-carousel')) return;
  class LPCarousel extends HTMLElement {
    connectedCallback() {
      if (this._on) return; this._on = true;
      var self = this;
      this.track = this.querySelector('[data-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.prev = this.querySelector('[data-prev]'); this.next = this.querySelector('[data-next]');
      var dots = this.querySelector('[data-dots]');
      if (this.slides.length < 2) { [this.prev, this.next, dots].forEach(function (el) { if (el) el.hidden = true; }); return; }
      dots.innerHTML = this.slides.map(function (s, i) { return '<button type="button" aria-label="photograph ' + (i + 1) + ' of ' + self.slides.length + '"></button>'; }).join('');
      this.dots = Array.prototype.slice.call(dots.children);
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });
      this.prev.addEventListener('click', function () { self.go(self.index() - 1); });
      this.next.addEventListener('click', function () { self.go(self.index() + 1); });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index() - 1); }
      });
      this.track.addEventListener('scroll', function () { self.sync(); }, { passive: true });
      window.addEventListener('resize', function () { self.sync(); });
      this.sync();
    }
    index() { var w = this.track.clientWidth || 1; return Math.round(this.track.scrollLeft / w); }
    go(i) {
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      var t = this.track, left = i * t.clientWidth;
      // Reduced motion asks for no glide, and a tab in the background never runs one: jump instead.
      if (document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        t.style.scrollBehavior = 'auto'; t.scrollLeft = left; t.style.scrollBehavior = ''; this.sync();
      } else t.scrollTo({ left: left, behavior: 'smooth' });
    }
    sync() {
      var i = this.index(), n = this.slides.length;
      if (i === this._i) return; this._i = i;
      this.prev.disabled = i <= 0; this.next.disabled = i >= n - 1;
      this.dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
  }
  customElements.define('lp-carousel', LPCarousel);
})();
